import { render } from "./PropsChat.vue?vue&type=template&id=b7525258"
import script from "./PropsChat.vue?vue&type=script&lang=js"
export * from "./PropsChat.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__